import { createRequest, createRequestHook } from "@shared/platform-api/requests"
import axios from "axios"
import { FeatureCollection, GeoJsonProperties, Geometry } from "geojson"
import { cast } from "@flockcover/flock-svc-core-types"
import {
  LineStringFeatureProperties,
  PointFeatureProperties,
  LineString,
  Point,
  Feature,
  LineStringFeaturePropertiesType,
  PointFeaturePropertiesType,
  GeoJson,
} from "../Map"

type Output = FeatureCollection<Geometry, GeoJsonProperties>

export const getGeoJson = createRequest<string, GeoJson>(async (geoJsonUrl: string): Promise<GeoJson> => {
  const result = await axios.get(geoJsonUrl)
  const t = transformGeoJson(result.data)
  return t
})

export const transformGeoJson = (geoJson: Output): GeoJson => {
  const lineStrings = geoJson.features
    .filter((x) => x.geometry.type === `LineString` && x.properties?.distance !== null)
    .map(
      (y) =>
        ({ ...y, properties: cast(LineStringFeaturePropertiesType)(y.properties) } as Feature<
          LineString,
          LineStringFeatureProperties
        >)
    )
  const points = geoJson.features
    .filter((x) => x.geometry.type === `Point`)
    .map(
      (y) =>
        ({ ...y, properties: cast(PointFeaturePropertiesType)(y.properties) } as Feature<Point, PointFeatureProperties>)
    )

  return {
    lineStrings,
    points,
  }
}

export const useGetGeoJson = createRequestHook<string, GeoJson>(getGeoJson, () => () => Promise.resolve(``))
